import { render, staticRenderFns } from "./DetailBreadcrumb.vue?vue&type=template&id=310fe534&scoped=true&"
import script from "./DetailBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DetailBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DetailBreadcrumb.vue?vue&type=style&index=0&id=310fe534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fe534",
  null
  
)

export default component.exports